<app-company-view *ngIf="authService.loggedInUser.company" [isCompanyAdmin]="true"></app-company-view>
